import { baseBUCGet } from '../base/baseBUC';

const str = '';
const decimal = 0.00;
const dateTimeStr = new Date()?.toISOString();

export const expenseTemplateModelGet = ({
    buildingId = '',
    userId = '',
}) => {
    return {
        balance: decimal,
        description: str,
        date: dateTimeStr,
        //details: [],
        details: [expenseTemplateDetailModelGet({})],
        ...baseBUCGet({ buildingId: buildingId, userId: userId, }),
    }
};

export const expenseTemplateDetailModelGet = ({
    id = '',
}) => {
    return {
        id: id,
        description: str,
        price: decimal,
        process: {
            detail: false,
            edit: false,
            delete: false,
        },
        quantity: decimal,
    }
}